import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, PickerController } from '@ionic/angular';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { AppComponent } from 'src/app/app.component';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import TagUtils from 'src/smoothr-web-app-core/utils/tag-utils';
import { getSlotsByOrder } from 'src/smoothr-web-app-core/utils/utils';
import moment, { Moment } from 'moment';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import { BeforeCreateOrderSelectTimeDialogComponent } from '../before-create-order-select-time-dialog/before-create-order-select-time-dialog.component';

@Component({
	selector: 'app-delivery-details-modal',
	templateUrl: './delivery-details-modal.component.html',
	styleUrls: ['./delivery-details-modal.component.scss'],
})
export class DeliveryDetailsModalComponent implements OnInit {
	public deliveryForm: FormGroup;
	public order: Order;
	public venue: Venue;
	public customer: Customer;
	public isOpeningTimeSheet: boolean = false;
	public loading: boolean = false;
	name = 'name';
	surname = 'surname';
	constructor(
		private modalCtrl: ModalController,
		private fb: FormBuilder,
		private pickerCtrl: PickerController,
		private ctrl: ChangeDetectorRef
	) {
		this.deliveryForm = fb.group({
			street: ['', Validators.required],
			number: ['', Validators.required],
			firma: [''],
			[this.name]: ['', [Validators.required]],
			[this.surname]: ['', [Validators.required]],
			phone: ['', [this._customRequiredPhone, this._customPhoneValidatorForLibrary]],
			orderAt: [''],
			asap: [''],
			email: [
				'',
				[
					Validators.required,
					Validators.pattern(
						"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
					),
				],
			],
		});
	}
	static async show(modalCtrl: ModalController, order: Order, venue: Venue, customer: Customer): Promise<Order> {
		const modal = await modalCtrl.create({
			cssClass: AppComponent.largeScreen ? 'sign-modal' : 'menu-modal',
			component: DeliveryDetailsModalComponent,
			componentProps: {
				order,
				venue,
				customer,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		console.log('customer', this.customer);

		if (this.customer) {
			const fullnameSplit = this.customer.name?.trim()?.split(/\s+/);
			this.deliveryForm.patchValue({
				street: this.order.preorder.street,
				number: this.order.preorder.number,
				name: fullnameSplit ? fullnameSplit[0] : '',
				surname: fullnameSplit ? fullnameSplit[1] : '',
				phone: {
					country: '+41',
					phone: this.customer.phone ? this.customer?.phone?.trim()?.replace('+41', '') : '',
				},
				email: this.order.preorder.email ?? this.customer?.email,
			});
		}

		this.deliveryForm.valueChanges.subscribe(v => {
			console.log(v);
			console.log(this.deliveryForm);
		});
	}
	private _customRequiredPhone(control: AbstractControl) {
		if (!control.value?.phone) {
			return { required: true };
		}

		return null;
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		if (String(control.value?.phone).length === 1) {
			return { invalidPhone: true };
		}
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

		try {
			const phoneNumber = phoneUtil.parse(control?.value?.country + control?.value?.phone.toString());
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.deliveryForm?.get(controlName)?.hasError('required') && this.deliveryForm?.get(controlName)?.touched;
		}
		return this.deliveryForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.deliveryForm?.get(controlName)?.errors && !this.deliveryForm?.get(controlName)?.hasError('required');
		}
		return this.deliveryForm.invalid;
	}
	getErrorsForm(controlName) {
		if (controlName) {
			return this.deliveryForm.get(controlName).errors;
		}

		return null;
	}
	// public async changeTime() {
	// 	const result = await BeforeCreateOrderSelectTimeDialogComponent.show(
	// 		this.modalCtrl,
	// 		this.order,
	// 		this.venue,
	// 		this.order.preorder.type
	// 	);
	//
	// 	// const result = await SelectTimeSlotDialogComponent.show(this.modalCtrl, this.order, this.venue);
	// 	// if (result?.asap) {
	// 	// 	this.order.asap = true;
	// 	// 	this.order.orderAt = null;
	// 	// }
	// 	if (result?.slot) {
	// 		this.order.asap = false;
	// 		this.order.orderAt = result.slot;
	// 		this.deliveryForm.patchValue({
	// 			orderAt: result.slot,
	// 			asap: false,
	// 		});
	// 	}
	// }
	slotToText(slot: Moment): string {
		const now = moment();
		const sameDay = slot.dayOfYear() === now.dayOfYear() && slot.year() === now.year();
		if (sameDay) {
			return slot.format('HH:mm');
		} else {
			return slot.format('HH:mm');
		}
	}
	async openTimeSheet() {
		if (this.isOpeningTimeSheet) {
			return;
		}
		this.isOpeningTimeSheet = true;
		try {
			let slots = (await getSlotsByOrder(this.venue, this.order)).map(slot => moment(slot.time));

			if ((slots.length === 1 && !slots[0]) || slots.length < 1) {
				this.isOpeningTimeSheet = false;
				this.loading = false;
				return;
			}

			let dates: Moment[] = [];
			const slotsForToday = slots.filter(it => {
				const insertedDate = dates.find(date => TimeUtils.isSameDate(date, it));
				if (!insertedDate) {
					dates.push(it);
				}
				return moment(it).isSame(moment(), 'day');
			});

			let slotsMap = slotsForToday.map(slot => {
				return {
					text: this.slotToText(slot ? moment(slot) : null),
					value: slot,
				};
			});
			console.log('DATES', dates);
			let daysMap = dates.map(slot => {
				return {
					text: moment(slot).format('dddd'),
					value: slot,
				};
			});
			const options = {
				cssClass: 'picker-time',
				columns: [
					{
						name: 'day',
						class: 'time-picker',

						options: daysMap,
					},
					{
						name: 'slot',
						class: 'time-picker',
						options: slotsMap,
					},
				],
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
					},
					{
						text: 'Select',
						handler: value => {
							if (value.day.text === 'ASAP') {
								this.deliveryForm.patchValue({
									orderAt: '',
									asap: true,
								});
								return;
							}
							const dayValue = moment(value.day.value).format('YYYY-MM-DD');
							const setTime = moment(value.slot.value).format('HH:mm');
							const finalTime = moment(dayValue + ' ' + setTime);
							this.deliveryForm.patchValue({
								orderAt: finalTime,
								asap: false,
							});
						},
					},
				],
			};
			const picker = await this.pickerCtrl.create(options);
			await picker.present();

			picker.columns[0].selectedIndex = 0;
			picker.addEventListener('ionPickerColChange', async (event: any) => {
				if (event.detail.name === 'day') {
					const selectedDay = daysMap[event.detail.selectedIndex];
					const foundSlotsForThisDay = slots.filter(slot => moment(selectedDay.value).isSame(moment(slot), 'd'));
					let newMappedSlots = foundSlotsForThisDay.map(slot => {
						return {
							text: this.slotToText(slot ? moment(slot) : null),
							value: slot,
						};
					});

					const timeColumn = await picker.getColumn('slot');
					timeColumn.options = newMappedSlots;
					timeColumn.selectedIndex = 0;
					picker.columns[1] = timeColumn;
					picker.columns = JSON.parse(JSON.stringify(picker.columns));
				}
			});
		} catch (e) {
			console.error(e);
		}
		this.isOpeningTimeSheet = false;
		this.loading = false;
	}
	tranformTime(time: Moment) {
		console.log(time);
		return moment(time).format('ddd HH:mm');
	}
	saveAndExit() {
		if (this.deliveryForm.invalid || this.checkerDate()) {
			this.markFormFieldsAsTouched(this.deliveryForm);
			this.deliveryForm.get('orderAt').setErrors({ required: true });
			return;
		}
		this.order.orderAt = this.deliveryForm?.get('orderAt')?.value;
		this.order.preorder.companyName = this.deliveryForm?.get('firma')?.value;
		this.order.preorder.name = this.deliveryForm?.get(this.name)?.value + ' ' + this.deliveryForm?.get(this.surname)?.value;
		this.order.preorder.phone = this.deliveryForm?.get('phone')?.value;
		if (this.deliveryForm.get('phone')?.value?.phone && this.deliveryForm.get('phone')?.value?.country)
			this.order.preorder.phone = this.deliveryForm.get('phone')?.value?.country + this.deliveryForm.get('phone')?.value?.phone;
		this.modalCtrl.dismiss(this.order);
	}
	checkerDate() {
		if (this.deliveryForm.get('asap')?.value) {
			return false;
		}
		if (this.deliveryForm.get('orderAt')?.value) {
			return false;
		}
		return true;
	}

	markFormFieldsAsTouched(form: FormGroup) {
		Object.keys(form.controls).forEach(field => {
			const control = form.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.markFormFieldsAsTouched(control);
			}
		});
	}
}
